import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import { optimizeLabelStack } from '../common/utils';
export function optimizeRequestInfo(requestInfo, interactionStart, reactUFOVersion) {
  var updatedRequestInfo = requestInfo.reduce(function (result, reqInfo) {
    var labelStack = reqInfo.labelStack,
      name = reqInfo.name,
      start = reqInfo.start,
      end = reqInfo.end,
      networkStart = reqInfo.networkStart,
      networkComplete = reqInfo.networkComplete;
    var startTime = networkStart !== null && networkStart !== void 0 ? networkStart : start;
    var endTime = networkComplete !== null && networkComplete !== void 0 ? networkComplete : end;
    if (labelStack && start >= interactionStart && endTime) {
      result.push({
        labelStack: optimizeLabelStack([].concat(_toConsumableArray(labelStack), [{
          name: name
        }]), reactUFOVersion),
        startTime: Math.round(startTime),
        endTime: Math.round(endTime)
      });
    }
    return result;
  }, []);
  return updatedRequestInfo;
}